import { describeIsItem } from './describe_is_item';
export const describeNull = ({
  is
}) => describeIsItem(is, 'null');
//# sourceMappingURL=describe_null.js.map